import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { FormsControllerModule } from './controllers/FormsController';
import { FormsCreateView } from './create/create';
import { FormsListView } from './list/list';
import { FormsPreviewView } from './preview/preview';

export const FormsView = angular
  .module('acme.view.application.forms', [
    uiRouter,
    'ui.bootstrap',
    FormsControllerModule,
    FormsListView,
    FormsCreateView,
    FormsPreviewView,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.forms',
      url: '/forms',
      views: {
        'subview-main': {
          controller: 'FormsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/forms/forms.tpl.html',
        },
      },
      data: {
        pageTitle: 'Forms',
        /** Secure With Permissions **/
        permissions: ['FORMS_VIEW'],
      },
    });
  }).name;
